var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareBtnIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4f3",
    d: "M4.411 0h16.178A4.411 4.411 0 0 1 25 4.411v16.178A4.411 4.411 0 0 1 20.589 25H4.411A4.411 4.411 0 0 1 0 20.589V4.411A4.411 4.411 0 0 1 4.411 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.719 8.824h-0.945c-0.501 0 -0.983 0.206 -1.339 0.574a2.008 2.008 0 0 0 -0.552 1.386v7.844c0 0.519 0.199 1.017 0.555 1.386 0.352 0.367 0.835 0.574 1.336 0.574h9.453c0.501 0 0.983 -0.206 1.339 -0.574 0.352 -0.367 0.552 -0.867 0.552 -1.386V10.784c0 -0.519 -0.2 -1.017 -0.555 -1.385a1.857 1.857 0 0 0 -1.336 -0.575h-0.945M12.5 13.725V2.941m0 0L9.664 5.883M12.5 2.941l2.836 2.941",
    stroke: "#1379EE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBtnIos);
export default __webpack_public_path__ + "static/media/shareBtnIos.74b09b962efdc9326f6ef9001a06cd6c.svg";
export { ForwardRef as ReactComponent };